import { Link } from "react-router-dom";
import { ABOUT_CONTENT, CONTACT_INFO } from "../utils/constants";
import useDocumentMeta from "../utils/useDocumentMeta";
import manojPortrait from "../../assets/manoj-kumar.jpeg";

const About = () => {
    useDocumentMeta(
        "About Manoj Kumar | 20+ Years Financial Consultant | PVM Consultants",
        "Manoj Kumar has 20+ years of experience managing investments, insurance, tax filing and loans for working professionals, with ₹5 Cr+ in client assets currently managed."
    );

    return (
        <section className="about-page">
            <div className="about-hero">
                <div className="about-experience">
                    <img src={manojPortrait} alt="Manoj Kumar, financial consultant at PVM Consultants" />
                    <div className="about-experience-badge">
                        <span>Established experience</span>
                        <strong>20+</strong>
                        <small>Years guiding financial decisions</small>
                    </div>
                </div>
                <div className="about-intro">
                    <span className="eyebrow">The advisor behind PVM</span>
                    <h1>{CONTACT_INFO.consultantName}</h1>
                    <p className="about-tagline">Financial consultant &middot; Personal portfolio guidance</p>
                    <p>{ABOUT_CONTENT.intro}</p>
                    <Link to="/contact" className="btn btn-primary">
                        Start a conversation
                    </Link>
                </div>
            </div>

            <section className="about-story">
                <div className="about-story-heading">
                    <span className="eyebrow">A more complete approach</span>
                    <h2>Advice built around the whole picture.</h2>
                </div>
                <div className="about-body">
                    {ABOUT_CONTENT.paragraphs.map((para, idx) => (
                        <p key={idx}>{para}</p>
                    ))}
                </div>
            </section>

            <div className="about-highlights">
                {ABOUT_CONTENT.highlights.map((item, index) => (
                    <div className="highlight-pill" key={item}>
                        <span>0{index + 1}</span>
                        <strong>{item}</strong>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default About;
